import { useQuery } from "@tanstack/vue-query";
import Billing from "@/services/billing/billing";

export interface CreditBalanceData {
  balanceCents: number;
  balanceUsd: string;
}

export function useCreditBalance() {
  return useQuery({
    queryKey: ["billing", "creditBalance"] as const,
    queryFn: async (): Promise<CreditBalanceData | null> => {
      const result = await Billing.getCreditBalance();
      const payload = result?.data as { status?: boolean; data?: Record<string, unknown> };
      if (payload?.status && payload?.data) {
        return {
          balanceCents: (payload.data.balanceCents as number) ?? 0,
          balanceUsd: (payload.data.balanceUsd as string) ?? "0.00",
        };
      }
      return null;
    },
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
